import { render, staticRenderFns } from "./EndCustomer.vue?vue&type=template&id=53230bab&scoped=true&"
import script from "./EndCustomer.vue?vue&type=script&lang=js&"
export * from "./EndCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53230bab",
  null
  
)

export default component.exports